var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.559,
    height: 22.576,
    viewBox: "0 0 22.559 22.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.894,
    y1: 0.706,
    x2: 0.147,
    y2: 0.193,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live_TV",
    "data-name": "Live TV",
    transform: "translate(-4 -3.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M22.01,33.646v-5.68a2.016,2.016,0,0,1,3.036-1.736l4.826,2.84a2.014,2.014,0,0,1,0,3.472l-4.826,2.84a2.016,2.016,0,0,1-3.036-1.736Zm2.417-4.975v4.271l3.629-2.135Z",
    transform: "translate(-10.755 -13.135)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M22.53,8.809H19.16l2.979-2.735A1.209,1.209,0,0,0,20.5,4.293L15.587,8.809h-.813L10.86,5.215a1.209,1.209,0,0,0-1.635,1.78L11.2,8.809H8.028A4.033,4.033,0,0,0,4,12.837V22.5a4.033,4.033,0,0,0,4.028,4.028h14.5A4.033,4.033,0,0,0,26.559,22.5V12.837A4.033,4.033,0,0,0,22.53,8.809Zm1.611,13.7a1.613,1.613,0,0,1-1.611,1.611H8.028A1.613,1.613,0,0,1,6.417,22.5V12.837a1.613,1.613,0,0,1,1.611-1.611h14.5a1.613,1.613,0,0,1,1.611,1.611Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTv);
export default __webpack_public_path__ + "static/media/live-tv.ea4d6107e522e38a66cfed0a138ae3fb.svg";
export { ForwardRef as ReactComponent };